import { Box } from '@chakra-ui/react';
import { TextTruncate } from '@time-line/components/common';

import { BlogSectionHeading } from '../BlogSectionHeading';

interface DisclaimerProps {
  text: string;
}

export function Disclaimer({ text }: DisclaimerProps) {
  return (
    <>
      <BlogSectionHeading id="disclaimer">Disclaimer</BlogSectionHeading>
      <Box mt="2xs">
        <TextTruncate
          noOfLines={5}
          size="detail"
          expandTextProps={{ size: 'overline' }}
        >
          {text}
        </TextTruncate>
      </Box>
    </>
  );
}
